// extracted by mini-css-extract-plugin
var _1 = "PostIcon-module__animateUploadProgressBarWidth--K7cQ8";
var _2 = "PostIcon-module__animatedBackground--v_5C2";
var _3 = "PostIcon-module__archived--agk0W";
var _4 = "PostIcon-module__bordered--QFjso";
var _5 = "PostIcon-module__container--gCxLc";
var _6 = "PostIcon-module__draft--6Lw54";
var _7 = "PostIcon-module__isArchived--Dxses";
var _8 = "PostIcon-module__isDraft--iWn6Z";
var _9 = "PostIcon-module__post--kT7kX";
var _a = "PostIcon-module__postIcon--RTegY";
var _b = "PostIcon-module__template--00dt0";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "archived", _4 as "bordered", _5 as "container", _6 as "draft", _7 as "isArchived", _8 as "isDraft", _9 as "post", _a as "postIcon", _b as "template" }
